import axios from 'axios';

/*
 * Migliora / Modifica immagini (components/imagestudio). Il backend inoltra a Photoroom o Claid
 * (chiavi in Impostazioni > Immagini) e salva il risultato su S3 con le thumbnail: ogni chiamata
 * che produce un'immagine ritorna { sizes, width, height } come le altre immagini della scheda.
 */
const state = {};

const getters = {};

const auth = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

// detail: spiegazione di Photoroom quando rifiuta l'immagine o le opzioni
const errore = err => {
	const data = (err.response && err.response.data) || {};
	return { error: data.message || err.message || 'photoroom_error', ...(data.detail ? { detail: data.detail } : {}) };
};

const actions = {
	// { photoroom: { available, sandbox, credits, error }, claid: {...} } — lo studio propone solo i fornitori attivi
	status: async context => {
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}imageedit/status`, { headers: auth(context) })
			.then(res => res.data.data)
			.catch(err => ({ photoroom: { available: false, ...errore(err) }, claid: { available: false, ...errore(err) } }));
	},

	// payload: { provider, op, url, params, uuid }
	process: async (context, payload) => {
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}imageedit/${payload.op}`,
				{ provider: payload.provider || 'photoroom', url: payload.url, params: payload.params || {}, uuid: payload.uuid },
				// le operazioni generative di Photoroom (sfondi, modella) possono richiedere oltre un minuto
				{ headers: auth(context), timeout: 200 * 1000 },
			)
			.then(res => res.data.data)
			.catch(errore);
	},

	// l'immagine come blob, servita dal backend: un canvas con un'immagine S3 senza CORS non si salva
	source: async (context, url) => {
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}imageedit/source`, { params: { url }, headers: auth(context), responseType: 'blob' })
			.then(res => ({ blob: res.data }))
			.catch(errore);
	},

	// payload: { blob, uuid } — risultato dell'editor manuale
	upload: async (context, payload) => {
		const form = new FormData();
		form.append('file', payload.blob, payload.blob.type === 'image/png' ? 'image.png' : 'image.jpg');
		form.append('uuid', payload.uuid);
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}imageedit/upload`, form, { headers: auth(context) })
			.then(res => res.data.data)
			.catch(errore);
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
